
<template>
  <div class="rerror-div">
    <div class="danghang-every">
      <div class="mainContainer">
        <span>当前位置：</span><span>学习中心</span><span> / </span><span>错题卡</span>
      </div>
    </div>
    <div class="mainContainer">
      <!-- <div class="rerror-title disFlex between">
        <div class="rerror-title-left disFlex">
          <div class="rerrorTimg"><img src="@/assets/images/6ad36e9fd101c0aa3f1e4722e6d73fa6.png" /></div>
          <div class="alignFlex between" style="padding: 10px 0;margin-left: 20px;">
            <div class="error-bt">这是标题这是标题这是标题这是标题这标题这是标题这是标题这是标题这是</div>
            <div class="error-js">总课时：23 | 3456人购买 | 有效期：2021-12-12 00:00</div>
          </div>
        </div>
        <div class="rerror-title-right">
          <div class="rerrorBack" @click="goBack">返回</div>
        </div>
      </div> -->
      <div class="disFlex between" style="margin-top: 26px;position: relative;">
        <div class="rerror-tiji">
          <div class="rerror-ti-block" v-for="(item,i) in tiji" :id="'tijiid'+i">
            <div class="rerror-ti-block-xh">{{i+1}}</div>
            <div v-if="item.itype=='1'">
              <div class="rerror-ti-block-typeName">[单选题]</div>
              <div class="rerror-ti-block-tiName">{{item.cname}}</div>
              <div v-for="(a,i) in item.daans" :class="'radioTm radioTm'+i">
                <el-radio v-model="item.myanswer" :label="a.order" size="medium">{{a.conts}}</el-radio>
              </div>
            </div>
            <div v-if="item.itype=='2'">
              <div class="rerror-ti-block-typeName">[多选题]</div>
              <div class="rerror-ti-block-tiName">{{item.cname}}</div>
              <div v-for="(a,i) in item.daans" :class="'checkboxTm checkboxTm'+i">
                <el-checkbox v-model="item.myanswer" :key="a.order" :label="a.order">{{a.conts}}</el-checkbox>
              </div>
            </div>
            <div v-if="item.itype=='3'">
              <div class="rerror-ti-block-typeName">[判断题]</div>
              <div class="rerror-ti-block-tiName">{{item.cname}}</div>
              <div class="radioTm radioTm0">
                <el-radio v-model="item.myanswer" label="1" size="medium">对</el-radio>
              </div>
              <div class="radioTm radioTm1">
                <el-radio v-model="item.myanswer" label="0" size="medium">错</el-radio>
              </div>
            </div>
            <div v-if="item.itype=='4'">
              <div class="rerror-ti-block-typeName">[填空题]</div>
              <div class="rerror-ti-block-tiName">
                <span v-for="a in item.daans" class="tiankong-inp">
                  <span v-if="a.type=='text'">{{a.conts}}</span>
                  <el-input v-else v-model="a.conts" placeholder="请输入内容"></el-input>
                </span>
              </div>
            </div>
            <div v-if="item.itype=='5'">
              <div class="rerror-ti-block-typeName">[简答题]</div>
              <div class="rerror-ti-block-tiName">{{item.cname}}</div>
              <div>
                <el-input type="textarea" :rows="2" placeholder="请输入您的答案" v-model="item.myanswer"></el-input>
              </div>
            </div>
          </div>
        </div>
        <div class="rerror-datika">
          <div class="disFlex between">
            <div class="rerror-datika-name">错题卡</div>
          </div>
          <div style="margin: 20px 0;">
            <el-button type="primary" class="rerror-prevbtn" @click="onSubmit(-1)">上一题</el-button>
          </div>
          <div style="margin: 20px 0;">
            <div class="rerror-nextbtn" @click="onSubmit(1)">下一题</div>
          </div>
          <div style="margin: 20px 0;">
            <div class="rerror-nextbtn" @click="goBack">返回</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    format
  } from '@/assets/js/common.js';
  export default {
    name: 'Kaoshi',
    props: ['KsBtnIsfixed'],
    data() {
      return {
        width: 'width:0%',
        progress: '0%',
        danxuanx: ['A', 'B', 'C', 'D', 'E', 'F', 'G'],
        tiji: [],
        yidaNum: 0,
        sjData: {},
        itypeList: [],
        startTime: ''
      }
    },
    methods: {
      onSubmit: function(index) {
        if (!this.tiji[0].myanswer || this.tiji[0].myanswer.length <= 0) {
          this.$message({
            message: '请先答题，再查看其它题目！',
            type: 'warning'
          });
        } else {
          this.saveTj(index);
        }
      },
      saveTj: function(index) {
        var tijilist = this.tiji;
        var list = []
        tijilist.map((item) => {
          var fraction = 0;
          if (item.itype == '1') {
            fraction = this.sjData.itype1Fraction
          } else if (item.itype == '2') {
            fraction = this.sjData.itype2Fraction
          } else if (item.itype == '3') {
            fraction = this.sjData.itype3Fraction
          } else if (item.itype == '4') {
            fraction = this.sjData.itype4Fraction
          } else if (item.itype == '5') {
            fraction = this.sjData.itype5Fraction
          }
          var obj = {
            questionsid: item.id,
            itype: item.itype,
            fraction: fraction,
            conts: item.myanswer
          };
          var a = [];
          item.daans.map((d) => {
            // 选择题
            if (item.itype == '1' && d.iscorrect == '1') {
              obj.daans = d.order;
            } else if (item.itype == '2' && d.iscorrect == '1') {
              // 多选题
              a.push(d.order);
            } else if (item.itype == '3') {
              // 判断题
              obj.daans = d.iscorrect;
            } else if (item.itype == '5') {
              obj.daans = d.keyword;
            }
          });
          if (item.itype == '2') {
            obj.daans = a.join(',');
            obj.conts = obj.conts.join(',');
          }
          list.push(obj);
        })
        var i = Number(this.sjData.i) + index;
        var params = {
          i: i,
          kid: this.sjData.kid,
          list: JSON.stringify(list)
        };
        this.getStlist(params);
      },
      getStlist: function(params) {
        var url = '/kt/ktProductAppy/geterrorlist.htm';
        if (params) {
          url += '?' + this.$qs.stringify(params);
        } else {
          url += '?id=' + this.$route.query.id;
        }
        this.$axios.get(url).then(res => {
          var data = res.data;
          if (data.stat == '1') {
            this.sjData = data.data;
            var list = [];
            var itypeList = [];
            [data.data].map((item, i) => {
              list.push({
                ...item,
                myanswer: item.itype == '2' ? [] : ''
              });
              if (i == 0 || item.itype != data.data.list[i - 1].itype) {
                itypeList.push(item.itype)
              }
            });
            this.tiji = list;
            this.itypeList = itypeList;
          } else {
            this.$message.error(data.message);
          }
        })
      },
      goToTiji: function(i) {
        var el = document.getElementById('tijiid' + i);
        $('#app').animate({
          scrollTop: el.offsetTop
        }, 300);
      },
      // 返回
      goBack: function() {
        this.$router.go(-1)
      }
    },
    components: {},
    created: function() {
      this.getStlist();

    }
  }
</script>

<style>
  .rerror-title {
    background-color: #fff;
    border-radius: 4px;
    padding: 20px;
  }

  .rerror-title-left {
    width: 815px;
  }

  .rerrorTimg img {
    width: 201px;
    height: 121px;
    opacity: 1;
    border-radius: 6px;
  }

  .rerrorBack {
    width: 86px;
    height: 32px;
    opacity: 1;
    background: #ffffff;
    border: 1px solid #0071ba;
    border-radius: 17px;
    line-height: 32px;
    text-align: center;
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 400;
    color: #0071ba;
    cursor: pointer;
  }

  .error-bt {
    height: 25px;
    opacity: 1;
    font-size: 18px;
    font-family: 'PingFangSC';
    font-weight: 500;
    text-align: left;
    color: #333333;
    line-height: 25px;
  }

  .error-js {
    height: 18px;
    opacity: 1;
    font-size: 13px;
    font-family: 'PingFangSC';
    font-weight: 400;
    text-align: left;
    color: #9a9a9a;
    line-height: 18px;
  }

  .rerror-tiji {
    width: 853px;
  }

  .rerror-ti-block {
    padding: 26px 40px 26px 66px;
    background: #ffffff;
    margin-bottom: 20px;
    position: relative;
  }

  .rerror-ti-block-xh {
    position: absolute;
    width: 44px;
    height: 37px;
    background: url(../../assets/images/ksxh.png) 0 0 no-repeat;
    background-size: 100% 100%;
    left: -10px;
    top: 21px;
    color: #fff;
    line-height: 29px;
    text-align: center;
  }

  .rerror-ti-block-typeName {
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 400;
    text-align: left;
    color: #0071BA;
    line-height: 20px;
    letter-spacing: 1px;
    padding-bottom: 8px;
  }

  .rerror-ti-block-tiName {
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 400;
    text-align: left;
    color: #333333;
    line-height: 20px;
    letter-spacing: 1px;
    margin-bottom: 22px;
  }

  /* 单选的样式   自定义 开始*/
  .radioTm {
    padding-bottom: 15px;
    text-align: left;
  }

  .radioTm .el-radio__inner {
    width: 24px;
    height: 24px;
    background: #efefef;
    border-radius: 50%;
  }

  .radioTm .el-radio__input.is-checked .el-radio__inner {
    background: #ff8b2e;
    border: 1px solid #ff8b2e;
  }

  .radioTm .el-radio__inner::after {
    background-color: transparent;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%) scale(1);
    color: #333;
    line-height: 24PX;
    text-align: center;
  }

  .radioTm0 .el-radio__inner::after {
    content: "A";
  }

  .radioTm1 .el-radio__inner::after {
    content: "B";
  }

  .radioTm2 .el-radio__inner::after {
    content: "C";
  }

  .radioTm3 .el-radio__inner::after {
    content: "D";
  }

  .radioTm .is-checked .el-radio__inner::after {
    color: #FFF;
  }

  .radioTm .el-radio__input.is-checked+.el-radio__label {
    color: #333;
  }

  /* 单选的样式   自定义 结束*/
  /* 多选的样式   自定义 开始*/
  .checkboxTm {
    text-align: left;
    padding-bottom: 15px;
  }

  .checkboxTm .el-checkbox__inner {
    width: 24px;
    height: 24px;
    background: #efefef;
    border-radius: 50%;
  }

  .checkboxTm .el-checkbox__inner::after {
    background-color: transparent;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%) scale(1);
    color: #333;
    line-height: 24PX;
    text-align: center;
  }

  .checkboxTm0 .el-checkbox__inner::after {
    content: "A";
  }

  .checkboxTm1 .el-checkbox__inner::after {
    content: "B";
  }

  .checkboxTm2 .el-checkbox__inner::after {
    content: "C";
  }

  .checkboxTm3 .el-checkbox__inner::after {
    content: "D";
  }

  .checkboxTm4 .el-checkbox__inner::after {
    content: "E";
  }

  .checkboxTm5 .el-checkbox__inner::after {
    content: "F";
  }

  .checkboxTm6 .el-checkbox__inner::after {
    content: "G";
  }

  .checkboxTm .el-checkbox__input.is-checked .el-checkbox__inner::after {
    transform: translate(-50%, -50%) scale(1);
    background-color: #ff8b2e;
    color: #fff;
  }

  .checkboxTm .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #ff8b2e;
  }

  .checkboxTm .el-checkbox__input.is-checked .el-checkbox__inner {
    border-color: #ff8b2e;
    background-color: #ff8b2e;
  }

  .checkboxTm .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #333;
  }

  /* 多选的样式   自定义 结束*/
  /* 输入框样式 */
  .tiankong-inp .el-input {
    width: 100px;
    margin: 0 5px;
  }

  .tiankong-inp .el-input .el-input__inner {
    border: none;
    border-bottom: 1px solid #d0d0d0;
    border-radius: 0;
  }

  /* 输入框样式 */
  .rerror-datika {
    width: 286px;
    background: #ffffff;
    padding: 20px;
    border-radius: 4px;
    position: relative;
    top: 0;
    right: 0;
  }

  .rerror-datika.fixed {
    position: fixed;
    top: 67px;
    right: calc(50% - 600px);
  }

  .rerror-datika .rerror-datika-name {
    font-size: 16px;
    font-family: 'PingFangSC';
    font-weight: 500;
    color: #333333;
    line-height: 22px;
    letter-spacing: 1px;
  }

  .rerror-prevbtn {
    width: 100%;
    border-radius: 25px;
    font-size: 20px;
    font-family: 'PingFangSC';
    font-weight: 500;
    letter-spacing: 2px;
  }

  .rerror-nextbtn {
    width: 100%;
    opacity: 1;
    background: #ffffff;
    border: 1px solid #0071ba;
    border-radius: 25px;
    opacity: 1;
    font-size: 20px;
    font-family: 'PingFangSC';
    font-weight: 500;
    text-align: center;
    color: #0071ba;
    letter-spacing: 2px;
    line-height: 38px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/xueyuan/reerror.vue